/**
 * Dash Domain Enums
 *
 * Shared enums used across client, admin, and edge apps.
 * These define the domain language for The Dash treasure hunts.
 */

/**
 * Difficulty levels for a Dash
 */
export enum DashDifficulty {
	Easy = "easy",
	Moderate = "moderate",
	Hard = "hard",
	Expert = "expert",
}

/**
 * Location mode determines if the Dash is location-specific or playable anywhere
 */
export enum DashLocationMode {
	Specific = "specific",
	Anywhere = "anywhere",
}

/**
 * Publication status of a Dash
 */
export enum DashStatus {
	Draft = "draft",
	Published = "published",
	Archived = "archived",
}

/**
 * Target audience categories
 */
export enum DashAudience {
	Family = "family",
	Teams = "teams",
	Couples = "couples",
	Solo = "solo",
	Corporate = "corporate",
}
